import { mixpanelTracking } from '@/services/mixpanel';
import Vue from 'vue';
export default Vue.extend({
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Error404',
    mounted() {
        mixpanelTracking('error: Acessou página 404');
    },
});
